import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Page from 'components/page';

import logoRanking from 'assets/images/logo-ranking.svg';
import { ContratosEmail } from './ContratosEmail';
import { ContratosPin } from './ContratosPin';
import { ContratosPanel } from './ContratosPanel';
import { useContratos } from './useContratos';
import * as Styled from './StyledContratos';

/**
 * Public counterparty contract-validation page (/contratos).
 * Three steps: corporate e-mail -> single-use PIN -> validation panel.
 */
export function Contratos() {
    const { t } = useTranslation('contratos');
    const cv = useContratos();

    const [step, setStep] = React.useState('email'); // email | pin | panel
    const [pendingEmail, setPendingEmail] = React.useState('');

    // "Home" desta página = início do fluxo (passo de e-mail).
    const goHome = () => {
        cv.reset();
        setPendingEmail('');
        setStep('email');
    };

    // back={false} desativa a seta padrão da navbar (que fazia "voltar do
    // navegador"). Usamos uma seta própria que volta ao início do fluxo.
    return (
        <Page.Page name="Contratos" menu={false} back={false}>
            <Styled.Header>
                {step !== 'email' && (
                    <button
                        type="button"
                        className="back far fa-arrow-left"
                        onClick={goHome}
                        aria-label="Voltar"
                    />
                )}
                <img src={logoRanking} alt="Ranking 100 Open Startups" className="logo" />
            </Styled.Header>

            {step === 'email' && (
                <ContratosEmail
                    t={t}
                    cv={cv}
                    onSent={email => {
                        setPendingEmail(email);
                        setStep('pin');
                    }}
                />
            )}

            {step === 'pin' && (
                <ContratosPin
                    t={t}
                    cv={cv}
                    email={pendingEmail}
                    onBack={() => setStep('email')}
                    onVerified={() => setStep('panel')}
                />
            )}

            {step === 'panel' && (
                <ContratosPanel
                    t={t}
                    cv={cv}
                    onExpired={() => {
                        cv.reset();
                        setStep('email');
                    }}
                />
            )}
        </Page.Page>
    );
}
export default Contratos;
